import Skeleton from '@mui/material/Skeleton';
import { Box } from 'shared/mui/Box';
import { Stack } from 'shared/mui/Stack/Stack';

export const MethodsEditFormSkeleton: React.FC = () => {
  return (
    <Box sx={{ width: '100%', marginTop: '22px' }}>
      <Skeleton height={24} sx={{ marginBottom: '24px' }} variant="rounded" width={100} />
      <Stack direction="row" gap="24px" mb="24px">
        <Skeleton height={40} variant="rounded" width="100%" />
        <Skeleton height={40} variant="rounded" width="100%" />
      </Stack>
      <Skeleton height={40} sx={{ marginBottom: '24px' }} variant="rounded" width="100%" />
      <Stack direction="row" gap="24px">
        <Stack flex={1} gap="24px">
          <Skeleton height={40} variant="rounded" />
          <Skeleton height={40} variant="rounded" />
        </Stack>
        <Stack flex={1}>
          <Skeleton height={104} variant="rounded" width={104} />
        </Stack>
      </Stack>
      <Stack direction="row" justifyContent="space-between" mt="24px">
        <Skeleton height={36} variant="rounded" width={100} />
        <Stack direction="row" gap={2}>
          <Skeleton height={36} variant="rounded" width={108} />
          <Skeleton height={36} variant="rounded" width={116} />
        </Stack>
      </Stack>
    </Box>
  );
};
